import { BaseComponent, IStateBase } from 'components/BaseComponent';
import { ICartModel } from 'interfaces/ICartModel';
import { IProductConfig, IProductData, IProduct } from 'interfaces/IProductData';
import React from 'react';
import { cartService } from 'services/CartService';
import { paymentService } from 'services/PaymentService';
import { Sidebar } from 'components/Cart/Sidebar/index';
import AddressAfter from './AddressAfter';
import { IPayProps } from 'components/Cart';
import { HistoryContext } from 'shared/HistoryContext';
import { History } from 'history';
import { Observable } from 'rxjs/Observable';
import StepUser from './StepUser';
import StepAddress from './StepAddress';
import StepPayment from './StepPayment';
import { langService } from 'services/LangService';
import { userService } from 'services/UserService';
import { TicketTimer } from 'components/Cart/TicketTimer';
import { enProductType } from 'enums/enProductType';
import StepTicket from './StepTicket';
import { Hidden } from '@material-ui/core';

const styles = require('./multiStep.css');

export enum enStep {
  user,
  address,
  payment,
  addressAfter,
  ticket
}

export interface IStepProps {
  setStep: (step: enStep) => void;
}

interface IState extends IStateBase {
  cart: IProductData;
  config: IProductConfig;
  model: ICartModel;
  step: enStep;
}

interface IProps extends IPayProps {
  product: IProduct;
}

export default class MultiStep extends BaseComponent<IState, IProps> {

  private history: History;

  constructor(props: any) {
    super(props);
  }

  componentDidMount() {
    this.observeState({ cart: null }, cartService.getCart());
    this.observeState({ config: null }, cartService.getConfig());
    this.bindModel(paymentService.getCart());
    this.setState({ step: enStep.user });

    langService.getLang()
      .bindComponent(this)
      .subscribe(() => this.setState({ step: enStep.user }));
  }

  setStep = (step: enStep) => {

    const { config } = this.state;

    if (step == enStep.address && !config.askAddressBeforePayment) {
      step = enStep.payment;
    }

    userService.setBasicUser().subscribe();

    this.setState({ step });
  }

  onPay = () => {

    if (paymentService.hasPaymentInProgress()) {
      return;
    }

    this.props
      .onPay()
      .switchMap(() => cartService.getCart())
      .switchMap(cart => {

        if (cart.config.askAddressAfterPayment) {
          this.setStep(enStep.addressAfter);
          return Observable.of(`/${cart.contentId}/addressafter`);
        }

        return paymentService.getPaymentResult()
          .map(result => {
            if (result.redirectTo) {
              Observable
                .never()
                .loader()
                .subscribe();

              window.location.href = result.redirectTo;
              return null;
            }

            return `/thankyou/${cart.contentId}/${result.key}`;
          });
      })
      .filter(url => url !== null)
      .bindComponent(this)
      .subscribe(url => {
        this.history.push(url);
      });
  }

  setHistory(history: History): any {
    this.history = history;
    return null;
  }

  render() {

    if (!this.state) {
      return '';
    }

    const { step, cart } = this.state;

    const { product } = this.props;

    return (
      <div className={styles.component}>
        <HistoryContext.Consumer>
          {h => this.setHistory(h)}
        </HistoryContext.Consumer>
        <div className='steps'>

          {cart.config.productType == enProductType.TICKET ?
            <Hidden smUp>
              <div className={'ticket'}>
                <TicketTimer />
              </div>
            </Hidden>
            : null
          }

          {enStep.user == step ? <StepUser setStep={this.setStep} product={product} onPay={this.onPay} /> : null}
          {enStep.ticket == step ? <StepTicket step={this.state.step} setStep={this.setStep} /> : null}
          {enStep.address == step ? <StepAddress step={this.state.step} setStep={this.setStep} onPay={this.onPay} /> : null}
          {enStep.payment == step ? <StepPayment step={this.state.step} setStep={this.setStep} onPay={this.onPay} /> : null}
          {enStep.addressAfter == step ? <AddressAfter setStep={this.setStep} history={this.history} /> : null}
        </div>
        <div className='sidebar'>
          <Sidebar cart={cart} />
        </div>
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/Cart/Templates/Mobile/MultiStep/index.tsx